export const externalPofolioContactLink = "https://nkwetachaterence.netlify.app/";